import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import toastr from 'toastr';
import usePost from '../../../../../hooks/shared/custom/data/geniatech/usePost';
import { GET_ROUTER_URL, GET_URL } from '../../../../../services/api/shared/BasestationsUrl';
import CustomCsvDownload from '../../../shared/CustomCsvDownload';
import { filename, assetTeamHeadersRestricted } from '../../../../../utils/field-support/installations/helpers';
import AssetTeamTable from '../../../shared/asset-team/AssetTeamTable';
import SearchByDetails from '../../asset-team/shared/SearchByDetails';
import CustomPagination from '../../../shared/CustomPagination';
import loader from '../../../../../assets/img/icons/TizetiLoaderColored.gif';



const CustomerActiveAndInactiveBody = ({ profile }) => {
  const { filtered, loading: postLoading, fetching, getData, getDataLegacy, fetchData, filterData } = usePost();
  const history = useHistory();
  const searchState = {
    fromDate: `${new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().slice(0, 10)}`,
    toDate: `${new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString().slice(0, 10)}`,
    country: 'Nigeria',
    filterBy: 'none',
    filterValue: '',
    status: 'expired',
    currentPage: 1,
    recordsPerPage: 500,
  };

  const [search, setSearch] = useState(searchState);
  const [allItems, setAllItems] = useState([]);
  const [fetchingAll, setFetchingAll] = useState(false);

  const loading = fetchingAll || postLoading || fetching;

  const { fromDate, toDate, country, filterBy, filterValue, currentPage, recordsPerPage, status } = search;

  const params = {
    action: 'tizeti_asset_active_inactive_users_list_range_paginated_restricted',
    from: fromDate,
    to: toDate,
    country,
    filterby: filterBy,
    filtervalue: filterValue,
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'filterBy') {
      const filterParams = {
        action: 'tizeti_asset_filter_values',
        country,
        filterby: value,
      };
      filterData(`${GET_URL}`, filterParams);
    }
    if (name === 'recordsPerPage') {
      setSearch({ ...search, recordsPerPage: Number(value), currentPage: 1 });
      return;
    }
    setSearch({ ...search, [name]: value });
  };

  const onPageChange = ({ selected }) => {
    setSearch({ ...search, currentPage: selected + 1 });
  };
const fetchAllRecords = async (fetchParams) => {
  if (fetchingAll) {
    return;
  }
  setFetchingAll(true);
  try {
  
      const firstResponse = await axios.post(
        `${GET_ROUTER_URL}`,
        qs.stringify({ ...fetchParams, pageno: 1, no_of_records_per_page: recordsPerPage }),
      );
      if (firstResponse.data && firstResponse.data.status === false) {
        toastr.error(firstResponse.data.message || 'Unable to load customers');
        setAllItems([]);
        return;
      }
      const totalPages = (firstResponse.data && firstResponse.data.total_pages) || 1;
      const firstItems = (firstResponse.data && firstResponse.data.items) || [];

      const remainingRequests = [];
      for (let page = 2; page <= totalPages; page += 1) {
        remainingRequests.push(
          axios.post(
            `${GET_ROUTER_URL}`,
            qs.stringify({ ...fetchParams, pageno: page, no_of_records_per_page: recordsPerPage }),
          ),
        );
      }
      const remainingResponses = await Promise.all(remainingRequests);
      const combined = remainingResponses.reduce((acc, response) => {
        const items = response.data && response.data.items;
        return items && items.length ? acc.concat(items) : acc;
      }, firstItems);

      setAllItems(combined);
      setSearch((prev) => ({ ...prev, currentPage: 1 }));
    } catch (e) {
      const errorMessage = (e.response && e.response.data && e.response.data.message) || e.message;
      toastr.error(errorMessage || 'Unable to load customers');
      setAllItems([]);
    } finally {
      setFetchingAll(false);
    }
  };

const onSearchByCountry = (e) => {
  e.preventDefault();
  if (loading) {
    return;
  }
  fetchAllRecords(params);
};

  useEffect(() => {
    fetchAllRecords(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const approvedEmails = [
      'marian.ishokare@tizeti.com',
      'ijem.okolugbo@tizeti.com',
      'jacob.brossa@tizeti.com',
      'customersupportDept@tizeti.com',
    ];
    if (profile.email) {
      const access = approvedEmails.includes(profile.email);

      if (access) {
      } else {
        sessionStorage.setItem('token', '');
        sessionStorage.clear();
        toastr.info('You are not allowed to view this page');
        history.push('/');
      }
    }
  }, [profile]);

  const pagesCount = Math.ceil(allItems.length / recordsPerPage) || 1;
  const pageItems = allItems.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);

  return (
    <div className="mt-5 px-3">
      <div className="container-fluid pt-5">
        <div className="row">
          <div className="p-0">
            <div className="col-12 d-flex">
              <form onSubmit={onSearchByCountry} className="form-inline ml-3">
                <div className="form-group">
                  <select defaultValue={country} name="country" onChange={handleChange} className="form-control">
                    <option value="">--Choose Country--</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Ghana">Ghana</option>
                  </select>
                </div>
                <div className="form-group mx-2">
                  <label className="mt-2 p-0 copy-font">From: </label>
                  <input
                    type="date"
                    className="form-control mr-2"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleChange}
                  />
                  <label className="mt-2 p-0 copy-font">To: </label>
                  <input type="date" className="form-control" name="toDate" value={toDate} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <select defaultValue={filterBy} name="filterBy" onChange={handleChange} className="form-control">
                    <option value="">--Filter By--</option>
                    <option value="agent">Agent</option>
                    <option value="basestation">Basestation</option>
                    <option value="zone">Zone</option>
                    <option value="subscription_status">Subscription Status</option>
                    <option value="none">All</option>
                  </select>
                </div>
                {filterBy !== 'none' && (
                  <div className="form-group">
                    <select
                      defaultValue={filterValue}
                      name="filterValue"
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">--Value--</option>
                      {filtered.items && filtered.items.length ? (
                        filtered.items.map((filter) => (
                          <option key={filter} value={filter}>
                            {filter}
                          </option>
                        ))
                      ) : (
                        <option>Loading...</option>
                      )}
                    </select>
                  </div>
                )}
                <div className="form-group">
                  <select defaultValue={status} name="status" onChange={handleChange} className="form-control">
                    <option>--Status--</option>
                    <option value="expired">EXPIRED</option>
                    <option value="active">ACTIVE</option>
                    <option value="none">ALL</option>
                  </select>
                </div>
                <div className="form-group mx-2">
                  <label className="mt-2 p-0 copy-font">Per page: </label>
                  <select
                    value={recordsPerPage}
                    name="recordsPerPage"
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                  </select>
                </div>
              <div className="form-group mx-2">
  <button className="btn btn-green" type="submit" disabled={loading}>
    Search
  </button>
</div>
              </form>
            </div>
            {loading && (
              <div className="col-12 ml-3 mt-2 d-flex align-items-center">
                <img src={loader} alt="Loading..." height="24" />
                <span className="ml-2">Loading...</span>
              </div>
            )}
            <SearchByDetails getData={getData} fetchData={fetchData} getDataLegacy={getDataLegacy} />
            {allItems.length ? (
              <div className="col-12 d-flex mt-2">
                <CustomCsvDownload
                  data={allItems}
                  headers={assetTeamHeadersRestricted}
                  filename={filename(`Active_Inactive ${country}`)}
                  classname="btn btn-green shadow-md"
                  textcolor="white"
                  text="Download Data"
                />
                <div className="pt-2 mx-3">
                  Count:
                  <span className="badge badge-secondary ml-1">{allItems.length}</span>
                </div>
              </div>
            ) : null}
          </div>
          <AssetTeamTable profile={profile} items={pageItems} load={loading} restricted="restricted" />
          {!loading && (
            <CustomPagination
              key={`${allItems.length}-${recordsPerPage}`}
              pagesCount={pagesCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerActiveAndInactiveBody;